import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../reducers/user.reducer';
import commonReducer from '../reducers/common.reducer';

export const store = configureStore({
  reducer: {
    userInfo: userReducer,
    commonReducer: commonReducer,
  },
});